import * as ActionTypes from "../actions/actiontypes"

export const initialState = {
    // Data
    routeSummaryData: [],
    routeDetailsData: [],
    doorDetailsData: [],
    
    // Filter Options
    filterOptions: {
        routes: [],
        doors: []
    },
    
    // Active Filters
    filters: {
        date: null,
        customer: null,
        dc: null,
        route: null,
        door: null
    },
    
    // Loading States
    loading: {
        routeSummary: false,
        routeDetails: false,
        doorDetails: false
    },
    
    // Error States
    error: {
        routeSummary: null,
        routeDetails: null,
        doorDetails: null
    }
}

const LoadValidationDashboardReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.UPDATE_LVD_FILTERS: {
            const { filterType, value } = action.payload;
            return {
                ...state,
                filters: { ...state.filters, [filterType]: value }
            };
        }
        
        // Route Summary
        case ActionTypes.LOAD_ROUTE_SUMMARY:
            return {
                ...state,
                loading: { ...state.loading, routeSummary: true },
                error: { ...state.error, routeSummary: null }
            };
        
        case ActionTypes.LOAD_ROUTE_SUMMARY_SUCCESS:
            return {
                ...state,
                loading: { ...state.loading, routeSummary: false },
                routeSummaryData: action.payload.data || [],
                error: { ...state.error, routeSummary: null }
            };
        
        case ActionTypes.LOAD_ROUTE_SUMMARY_ERROR:
            return {
                ...state,
                loading: { ...state.loading, routeSummary: false },
                error: { ...state.error, routeSummary: errorDescription(action.error) }
            };
        
        // Route Details
        case ActionTypes.LOAD_ROUTE_DETAILS:
            return {
                ...state,
                loading: { ...state.loading, routeDetails: true },
                error: { ...state.error, routeDetails: null }
            };
        
        case ActionTypes.LOAD_ROUTE_DETAILS_SUCCESS: {
            const detailRouteMap = new Map();
            (action.payload.data || []).forEach(r => {
                if (r.route_system_id && r.local_route && !detailRouteMap.has(r.route_system_id)) {
                    detailRouteMap.set(r.route_system_id, { id: r.route_system_id, label: r.local_route });
                }
            });
            return {
                ...state,
                loading: { ...state.loading, routeDetails: false },
                routeDetailsData: action.payload.data || [],
                filterOptions: {
                    ...state.filterOptions,
                    routes: Array.from(detailRouteMap.values())
                },
                error: { ...state.error, routeDetails: null }
            };
        }
        
        case ActionTypes.LOAD_ROUTE_DETAILS_ERROR:
            return {
                ...state,
                loading: { ...state.loading, routeDetails: false },
                error: { ...state.error, routeDetails: errorDescription(action.error) }
            };
        
        // Door Details
        case ActionTypes.LOAD_DOOR_DETAILS:
            return {
                ...state,
                loading: { ...state.loading, doorDetails: true },
                error: { ...state.error, doorDetails: null }
            };
        
        case ActionTypes.LOAD_DOOR_DETAILS_SUCCESS:
            return {
                ...state,
                loading: { ...state.loading, doorDetails: false },
                doorDetailsData: action.payload.data || [],
                error: { ...state.error, doorDetails: null }
            };
        
        case ActionTypes.LOAD_DOOR_DETAILS_ERROR:
            return {
                ...state,
                loading: { ...state.loading, doorDetails: false },
                error: { ...state.error, doorDetails: errorDescription(action.error) }
            };

        case ActionTypes.LOAD_ROUTE_LIST_SUCCESS:
            return {
                ...state,
                filterOptions: {
                    ...state.filterOptions,
                    routes: action.payload.routes || []
                }
            };

        case ActionTypes.LOAD_ROUTE_LIST_ERROR:
            return state;

        case ActionTypes.LOAD_DOOR_LIST_SUCCESS:
            return {
                ...state,
                filterOptions: {
                    ...state.filterOptions,
                    doors: (action.payload.doors || []).map(d => ({ id: d, label: d }))
                }
            };

        case ActionTypes.LOAD_DOOR_LIST_ERROR:
            return state;

        default:
            return state;
    }
}

const errorDescription = (error) => {
    if (error && error.code === 'ECONNABORTED') {
        return 'Request timed out. Please try again.';
    }
    return 'Unable to load data. Please try again.';
}

export default LoadValidationDashboardReducer;
